import { useEffect, useState } from 'react';
import Text from '../../atoms/Text';

type headerType = {
  id: string;
  Header: string;
  left?: boolean;
  width: number;
  tooltipMes?: string;
  filterable: boolean;
};

type sortType = { id: string; type: 'ASC' | 'DESC' };

const getSymbol = (sort: sortType, name: string) => {
  if (sort.id === name) {
    return (
      <div
        className={`${
          sort.type === 'DESC' ? 'icon-chevron-down' : 'icon-chevron-top'
        } seo_page__table__content__headers__item__icon`}
      />
    );
  }
};

interface IPairsTableProps {
  title?: string;
  headers: headerType[];
  data: Record<string, string | number>[];
  renderCell(
    cell: headerType,
    item: Record<string, string | number>,
    index: number
  ): JSX.Element;
  initSortColumn: string;
  padding?: string;
}

const PairsTable = ({
  title,
  headers,
  data,
  renderCell,
  initSortColumn,
  padding,
}: IPairsTableProps) => {
  const [showMarkets, setShowMarkets] = useState(false);
  const [sortedData, setSortedData] = useState<
    Record<string, string | number>[]
  >([]);
  const [sort, setSort] = useState<sortType>({
    id: initSortColumn,
    type: 'DESC',
  });

  useEffect(() => {
    if (data && data.length > 0) {
      const sorted = data.sort((a, b) => {
        if (a[sort.id] === b[sort.id]) {
          return 0;
        }
        if (a[sort.id] === '-') {
          if (sort.type === 'DESC') {
            return -1;
          }

          return 1;
        }
        if (b[sort.id] === '-') {
          if (sort.type === 'DESC') {
            return 1;
          }

          return -1;
        }
        return (
          parseFloat(a[sort.id].toString().replace(/[^\d.-]/g, '')) -
          parseFloat(b[sort.id].toString().replace(/[^\d.-]/g, ''))
        );
      });

      if (sort.type === 'ASC') {
        setSortedData(sorted);
      } else {
        setSortedData([...sorted.reverse()]);
      }
    }
  }, [data, sort]);

  const onSort = (name: string) => {
    if (sort.id === name && sort.type === 'ASC') {
      return setSort({ id: name, type: 'DESC' });
    }
    if (sort.id === name && sort.type === 'DESC') {
      return setSort({ id: name, type: 'ASC' });
    }

    setSort({ id: name, type: 'DESC' });
  };

  return (
    <div className='seo_page__table' style={{ padding }}>
      {title && (
        <div className='seo_page__table__title'>
          <Text size={18} className='text--grey-200 text--weight-500'>
            {title}
          </Text>
        </div>
      )}
      <div className='seo_page__table__wrapper'>
        <div className='seo_page__table__content'>
          <div className='seo_page__table__content__headers'>
            {headers.map((header) => (
              <div
                key={header.id}
                className={`seo_page__table__content__headers__item ${
                  header.left
                    ? 'seo_page__table__content__headers__item--left'
                    : ''
                } ${header.filterable ? 'text--clickable' : ''}`}
                style={{ width: header.width }}
                onClick={
                  header.filterable ? () => onSort(header.id) : undefined
                }
              >
                <Text size={12} className='text--weight-600 text--grey-600'>
                  {header.Header}
                </Text>
                {getSymbol(sort, header.id)}
              </div>
            ))}
          </div>
          {sortedData?.slice(0, 10).map((item) => (
            <div
              key={item.star}
              className='seo_page__table__content__rows text--grey-400'
            >
              {headers.map((header) => (
                <div
                  key={header.id + item.star}
                  className={`seo_page__table__content__rows__item ${
                    header.left
                      ? 'seo_page__table__content__rows__item--left'
                      : ''
                  }`}
                  style={{ width: header.width }}
                >
                  {renderCell(header, item, +item.star - 1)}
                </div>
              ))}
            </div>
          ))}
          {showMarkets &&
            sortedData?.slice(10).map((item) => (
              <div
                key={item.star}
                className='seo_page__table__content__rows_second_part text--grey-400'
              >
                {headers.map((header) => (
                  <div
                    key={header.id + item.star}
                    className={`seo_page__table__content__rows__item ${
                      header.left
                        ? 'seo_page__table__content__rows__item--left'
                        : ''
                    }`}
                    style={{ width: header.width }}
                  >
                    {renderCell(header, item, +item.star - 1)}
                  </div>
                ))}
              </div>
            ))}
        </div>
      </div>
      <div className='seo_page__table__additional'>
        <Text size={12} className='text--grey-600'>
          Do Your Own Research, Markets can move very quickly and it takes time
          to build your knowledge.
        </Text>
        {data.length > 10 && (
          <div
            className='seo_page__table__additional__btn'
            onClick={() => setShowMarkets(!showMarkets)}
          >
            <Text size={12} className='text--weight-600 text--white'>
              {showMarkets ? 'Hide' : 'See All Markets'}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default PairsTable;
